import { InputCurrencyGroup } from "@finanedi.es/storybook"
import { InputText } from "primereact/inputtext"
import React, { useEffect } from "react"
import { useTranslation } from "react-i18next"

const TemplateIvaDevengado = ({
  fields,
  isDeducible,
  setValue,
  watch,
  calculateBaseImponible33,
  calculateIvaDevengado34,
  calculateRecargoEquivalencia47,
}: $TSMigrationFixMe) => {
  const formValues = watch()
  // Recalcular automáticamente las cuotas cuando cambien las bases
  useEffect(() => {
    // TODO DESCOMENTAR CUANDO SE HAGA ENDPOINT DECLARACION 390
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    fields.forEach((field: any) => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      field.columnOne?.forEach((colOne: any, index: number) => {
        if (!colOne) return

        const colTwo = field.columnTwo?.[index]
        const colThree = field.columnThree?.[index]

        // Solo calcular si la cuota NO está deshabilitada y el porcentaje es numérico
        if (!colTwo || !colThree || colThree.disabled) return
        if (typeof colTwo.value !== "number" || colTwo.value === 0) return

        const baseValue = Number(watch(`${colOne.code}`)) || 0

        // Solo calcular si hay base imponible
        if (baseValue > 0) {
          const calculatedValue =
            Math.round(((baseValue * colTwo.value) / 100) * 100) / 100
          const currentValue = Number(watch(`${colThree.code}`)) || 0

          // Solo actualizar si el valor calculado difiere del actual (evita loops)
          if (Math.abs(calculatedValue - currentValue) > 0.01) {
            setValue(`${colThree.code}`, calculatedValue, {
              shouldValidate: false,
              shouldDirty: true,
            })
          }
        }
      })
    })
  }, [formValues, fields, setValue, watch])
  const { t } = useTranslation()
  return (
    <div className='tw-w-full tw-flex tw-flex-col'>
      <div className='tw-w-full tw-grid tw-grid-cols-[2fr_1fr_60px_1fr] tw-gap-2 tw-border-b tw-border-gray-200 tw-py-1 tw-items-start'>
        <div />
        <div className='tw-text-xs tw-font-medium tw-text-center'>
          {t("taxSummary.declaracion.liquidacionModelo.box2titleOne")}
        </div>
        <div className='tw-text-xs tw-font-medium tw-text-center'>
          {t("taxSummary.declaracion.liquidacionModelo.box2titleTwo")}
        </div>
        <div className='tw-text-xs tw-font-medium tw-text-center'>
          {isDeducible
            ? t("taxSummary.declaracion.liquidacionModelo.box3titleTwo")
            : t("taxSummary.declaracion.liquidacionModelo.box3titleOne")}
        </div>
      </div>
      {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        fields.map((field: any) => {
          const rowsCount = Math.max(
            field.columnOne?.length ?? 0,
            field.columnTwo?.length ?? 0,
            field.columnThree?.length ?? 0
          )

          return (
            <div
              key={field.label}
              className='tw-w-full tw-h-fit tw-grid tw-grid-cols-[2fr_1fr_60px_1fr] tw-gap-2 tw-border-b tw-border-gray-200 tw-py-3 tw-items-start'
            >
              <div
                className='tw-text-sm tw-border-r tw-h-full tw-flex tw-items-center tw-border-r-gray-200 last:tw-font-medium'
                style={{ gridRow: `span ${rowsCount}` }}
              >
                {field.label}
              </div>

              {Array.from({ length: rowsCount }).map((_, rowIndex) => {
                const colOne = field.columnOne?.[rowIndex]
                const colTwo = field.columnTwo?.[rowIndex]
                const colThree = field.columnThree?.[rowIndex]

                const baseImponibleFormValue =
                  watch?.(`${colOne?.code}`) ?? colOne?.value ?? 0
                const devengadaValue = watch?.(`${colThree?.code}`) ?? 0
                return (
                  // eslint-disable-next-line react/no-array-index-key
                  <React.Fragment key={rowIndex}>
                    {colOne && (
                      <>
                        <div>
                          <InputCurrencyGroup
                            suffix='€'
                            // value={colOne?.value ?? 0}
                            value={
                              colOne?.inputNumber === "33"
                                ? calculateBaseImponible33
                                : baseImponibleFormValue
                            }
                            placeholder='0,00'
                            className='tw-w-full tw-h-full tw-text-sm'
                            numberGroup={colOne?.inputNumber ?? ""}
                            disabled={colOne?.disabled ?? false}
                            onChange={(value: number | undefined) => {
                              setValue(`${colOne?.code}`, value || 0)
                            }}
                          />
                        </div>

                        <div className='tw-text-center'>
                          <InputText
                            className='tw-text-sm tw-w-14 tw-text-center'
                            value={colTwo?.value ?? ""}
                            disabled={colTwo?.disabled ?? false}
                          />
                        </div>
                      </>
                    )}

                    <div className={`${!colOne ? "tw-col-start-4" : ""}`}>
                      <InputCurrencyGroup
                        suffix='€'
                        value={
                          colThree?.inputNumber === "34"
                            ? calculateIvaDevengado34
                            : colThree?.inputNumber === "47"
                            ? calculateRecargoEquivalencia47
                            : devengadaValue
                        }
                        placeholder='0,00'
                        className='tw-w-full tw-h-full tw-text-sm'
                        numberGroup={colThree?.inputNumber ?? ""}
                        disabled={colThree?.disabled ?? false}
                        onChange={(value: number | undefined) =>
                          setValue(`${colThree?.code}`, value || 0)
                        }
                      />
                    </div>
                  </React.Fragment>
                )
              })}
            </div>
          )
        })
      }
    </div>
  )
}

export default TemplateIvaDevengado
